import type { ListBuilderConfiguration } from '../../types';
import { allSensorDevicesList } from './lists/all-sensor-devices';

/**
 * Sensor device list configuration (PD-13926). Backed by the sensor_device
 * entity; the quick `deviceFilter` (Needs Attention / Has Orphans /
 * Unattached) is resolved server-side.
 */
export const SENSOR_DEVICE_LIST_CONFIG: ListBuilderConfiguration = {
	lists: [allSensorDevicesList],
	paging: {
		defaultPageSize: 20,
		pageSizeOptions: [10, 20, 50, 100],
	},
	filters: {
		activeFilters: ['sensorDeviceSearch', 'deviceFilter'],
		defaultFilters: {},
	},
	tableSorts: [
		{
			id: 'sensor-device-id',
			name: 'Device ID (A-Z)',
			fields: [
				{
					direction: 'ASC',
					fieldName: 'deviceId',
					objectTable: 'sensor_device',
				},
			],
			description: 'Sort devices by device ID',
		},
		{
			id: 'sensor-device-id-desc',
			name: 'Device ID (Z-A)',
			fields: [
				{
					direction: 'DESC',
					fieldName: 'deviceId',
					objectTable: 'sensor_device',
				},
			],
			description: 'Sort devices by device ID, descending',
		},
		{
			// The Status column renders the derived healthState, which has no
			// SQL column to sort by; this preset sorts by the reported status
			// the device last sent, hence the distinct name (PD-15562).
			id: 'status-asc',
			name: 'Reported Status (A-Z)',
			fields: [
				{ direction: 'ASC', fieldName: 'status', objectTable: 'sensor_device' },
				{
					direction: 'ASC',
					fieldName: 'deviceId',
					objectTable: 'sensor_device',
				},
			],
			description:
				'Group devices by their last reported status, then by device ID',
		},
		{
			id: 'last-seen-desc',
			name: 'Last Seen (Newest)',
			fields: [
				{
					direction: 'DESC',
					fieldName: 'lastSeen',
					objectTable: 'sensor_device',
				},
			],
			description: 'Sort devices by most recent report',
		},
	],
	objects: [
		{
			baseUrl: '/distribution/sensor-devices/:id',
			objectLabel: 'Sensor Device',
			objectTable: 'sensor_device',
			selectedFields: [
				{ fieldName: '_id', fieldLabel: 'ID' },
				{ fieldName: 'id', fieldLabel: 'ID' },
				{ fieldName: 'deviceId', fieldLabel: 'Device ID' },
				{ fieldName: 'name', fieldLabel: 'Name' },
				{ fieldName: 'merchandiserLabel', fieldLabel: 'Merchandiser' },
				{
					fieldName: 'merchandiserSerialLabel',
					fieldLabel: 'Merchandiser Serial',
				},
				{ fieldName: 'placementLabel', fieldLabel: 'Placement' },
				{ fieldName: 'placementDetail', fieldLabel: 'Placement Address' },
				{ fieldName: 'healthState', fieldLabel: 'Status' },
				{ fieldName: 'status', fieldLabel: 'Reported Status' },
				{ fieldName: 'healthLabel', fieldLabel: 'Sensors / Battery' },
				{ fieldName: 'coverageLabel', fieldLabel: 'Sensors' },
				{ fieldName: 'batteryLabel', fieldLabel: 'Battery' },
				{ fieldName: 'lastSeenLabel', fieldLabel: 'Last Seen' },
				{ fieldName: 'lastSeen', fieldLabel: 'Last Seen' },
			],
		},
	],
};
